/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetModuleListForRecordDocument = gql`
    query getModuleListForRecord($companyId: Int!) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      id
      name
      deleted
      phone
      address
      bookingQrLink
      currency {
        id
        currencySign
      }
      country {
        isoCode
      }
      modules {
        id
        name
        active(companyId: $companyId)
      }
    }
  }
}
    `;

/**
 * __useGetModuleListForRecordQuery__
 *
 * To run a query within a React component, call `useGetModuleListForRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModuleListForRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModuleListForRecordQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetModuleListForRecordQuery(baseOptions: Apollo.QueryHookOptions<GetModuleListForRecordQuery, GetModuleListForRecordQueryVariables> & ({ variables: GetModuleListForRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModuleListForRecordQuery, GetModuleListForRecordQueryVariables>(GetModuleListForRecordDocument, options);
      }
export function useGetModuleListForRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModuleListForRecordQuery, GetModuleListForRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModuleListForRecordQuery, GetModuleListForRecordQueryVariables>(GetModuleListForRecordDocument, options);
        }
export function useGetModuleListForRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModuleListForRecordQuery, GetModuleListForRecordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModuleListForRecordQuery, GetModuleListForRecordQueryVariables>(GetModuleListForRecordDocument, options);
        }
export type GetModuleListForRecordQueryHookResult = ReturnType<typeof useGetModuleListForRecordQuery>;
export type GetModuleListForRecordLazyQueryHookResult = ReturnType<typeof useGetModuleListForRecordLazyQuery>;
export type GetModuleListForRecordSuspenseQueryHookResult = ReturnType<typeof useGetModuleListForRecordSuspenseQuery>;
export type GetModuleListForRecordQueryResult = Apollo.QueryResult<GetModuleListForRecordQuery, GetModuleListForRecordQueryVariables>;
export const GetTechnologicalMapsServiceDocument = gql`
    query getTechnologicalMapsService($serviceId: Int, $companyId: Int!, $branchId: Int!, $inStockProducts: Boolean, $bookingUuid: Uuid) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      id
      name
      deleted
      phone
      address
      bookingQrLink
      technologicalMaps(
        branchId: $branchId
        serviceId: $serviceId
        isDeleted: false
        inStockProducts: $inStockProducts
        bookingUuid: $bookingUuid
      ) {
        technologicalMaps {
          id
          name
          deleted
        }
      }
    }
  }
}
    `;

/**
 * __useGetTechnologicalMapsServiceQuery__
 *
 * To run a query within a React component, call `useGetTechnologicalMapsServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTechnologicalMapsServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTechnologicalMapsServiceQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      inStockProducts: // value for 'inStockProducts'
 *      bookingUuid: // value for 'bookingUuid'
 *   },
 * });
 */
export function useGetTechnologicalMapsServiceQuery(baseOptions: Apollo.QueryHookOptions<GetTechnologicalMapsServiceQuery, GetTechnologicalMapsServiceQueryVariables> & ({ variables: GetTechnologicalMapsServiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTechnologicalMapsServiceQuery, GetTechnologicalMapsServiceQueryVariables>(GetTechnologicalMapsServiceDocument, options);
      }
export function useGetTechnologicalMapsServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTechnologicalMapsServiceQuery, GetTechnologicalMapsServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTechnologicalMapsServiceQuery, GetTechnologicalMapsServiceQueryVariables>(GetTechnologicalMapsServiceDocument, options);
        }
export function useGetTechnologicalMapsServiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTechnologicalMapsServiceQuery, GetTechnologicalMapsServiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTechnologicalMapsServiceQuery, GetTechnologicalMapsServiceQueryVariables>(GetTechnologicalMapsServiceDocument, options);
        }
export type GetTechnologicalMapsServiceQueryHookResult = ReturnType<typeof useGetTechnologicalMapsServiceQuery>;
export type GetTechnologicalMapsServiceLazyQueryHookResult = ReturnType<typeof useGetTechnologicalMapsServiceLazyQuery>;
export type GetTechnologicalMapsServiceSuspenseQueryHookResult = ReturnType<typeof useGetTechnologicalMapsServiceSuspenseQuery>;
export type GetTechnologicalMapsServiceQueryResult = Apollo.QueryResult<GetTechnologicalMapsServiceQuery, GetTechnologicalMapsServiceQueryVariables>;
export const GetUserRoleForRecordDocument = gql`
    query getUserRoleForRecord($companyId: Int!) {
  user(companyId: $companyId) {
    id
    employee(companyId: $companyId) {
      id
      name
      phone
      email
      tariffBlocking
      manualBlocking
    }
    role(companyId: $companyId) {
      id
      name
      isOwner
    }
  }
}
    `;

/**
 * __useGetUserRoleForRecordQuery__
 *
 * To run a query within a React component, call `useGetUserRoleForRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRoleForRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRoleForRecordQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetUserRoleForRecordQuery(baseOptions: Apollo.QueryHookOptions<GetUserRoleForRecordQuery, GetUserRoleForRecordQueryVariables> & ({ variables: GetUserRoleForRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRoleForRecordQuery, GetUserRoleForRecordQueryVariables>(GetUserRoleForRecordDocument, options);
      }
export function useGetUserRoleForRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRoleForRecordQuery, GetUserRoleForRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRoleForRecordQuery, GetUserRoleForRecordQueryVariables>(GetUserRoleForRecordDocument, options);
        }
export function useGetUserRoleForRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserRoleForRecordQuery, GetUserRoleForRecordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserRoleForRecordQuery, GetUserRoleForRecordQueryVariables>(GetUserRoleForRecordDocument, options);
        }
export type GetUserRoleForRecordQueryHookResult = ReturnType<typeof useGetUserRoleForRecordQuery>;
export type GetUserRoleForRecordLazyQueryHookResult = ReturnType<typeof useGetUserRoleForRecordLazyQuery>;
export type GetUserRoleForRecordSuspenseQueryHookResult = ReturnType<typeof useGetUserRoleForRecordSuspenseQuery>;
export type GetUserRoleForRecordQueryResult = Apollo.QueryResult<GetUserRoleForRecordQuery, GetUserRoleForRecordQueryVariables>;
export const CheckBranchDataForRecordDocument = gql`
    query CheckBranchDataForRecord($companyId: Int!, $branchId: Int!) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branches(id: $branchId) {
        isAnyActiveServiceEmployeeRelations
        isAnyActiveServices
        isAnyWorkScheduleForWorkingEmployees
        employeesPaginated(onlyActive: true) {
          totalCount
        }
        bookingsList {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useCheckBranchDataForRecordQuery__
 *
 * To run a query within a React component, call `useCheckBranchDataForRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckBranchDataForRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckBranchDataForRecordQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useCheckBranchDataForRecordQuery(baseOptions: Apollo.QueryHookOptions<CheckBranchDataForRecordQuery, CheckBranchDataForRecordQueryVariables> & ({ variables: CheckBranchDataForRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckBranchDataForRecordQuery, CheckBranchDataForRecordQueryVariables>(CheckBranchDataForRecordDocument, options);
      }
export function useCheckBranchDataForRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckBranchDataForRecordQuery, CheckBranchDataForRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckBranchDataForRecordQuery, CheckBranchDataForRecordQueryVariables>(CheckBranchDataForRecordDocument, options);
        }
export function useCheckBranchDataForRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckBranchDataForRecordQuery, CheckBranchDataForRecordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckBranchDataForRecordQuery, CheckBranchDataForRecordQueryVariables>(CheckBranchDataForRecordDocument, options);
        }
export type CheckBranchDataForRecordQueryHookResult = ReturnType<typeof useCheckBranchDataForRecordQuery>;
export type CheckBranchDataForRecordLazyQueryHookResult = ReturnType<typeof useCheckBranchDataForRecordLazyQuery>;
export type CheckBranchDataForRecordSuspenseQueryHookResult = ReturnType<typeof useCheckBranchDataForRecordSuspenseQuery>;
export type CheckBranchDataForRecordQueryResult = Apollo.QueryResult<CheckBranchDataForRecordQuery, CheckBranchDataForRecordQueryVariables>;
export type GetModuleListForRecordQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetModuleListForRecordQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', id: number, name: string, deleted: boolean, phone: string, address: string, bookingQrLink: string, currency?: { __typename?: 'CurrencyProxy', id: number, currencySign?: string | null } | null, country?: { __typename?: 'CountryProxy', isoCode?: string | null } | null, modules?: Array<{ __typename?: 'ModuleProxy', id: number, name?: string | null, active: boolean }> | null } | null } | null };

export type GetTechnologicalMapsServiceQueryVariables = Types.Exact<{
  serviceId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  inStockProducts?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  bookingUuid?: Types.InputMaybe<Types.Scalars['Uuid']['input']>;
}>;


export type GetTechnologicalMapsServiceQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', id: number, name: string, deleted: boolean, phone: string, address: string, bookingQrLink: string, technologicalMaps?: { __typename?: 'TechnologicalMapPaginated', technologicalMaps?: Array<{ __typename?: 'TechnologicalMapProxy', id: number, name: string, deleted: boolean }> | null } | null } | null } | null };

export type GetUserRoleForRecordQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetUserRoleForRecordQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, employee?: { __typename?: 'EmployeeProxy', id: number, name?: string | null, phone: string, email: string, tariffBlocking: boolean, manualBlocking: boolean } | null, role?: { __typename?: 'RoleProxy', id: number, name: string, isOwner: boolean } | null } | null };

export type CheckBranchDataForRecordQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
}>;


export type CheckBranchDataForRecordQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', isAnyActiveServiceEmployeeRelations: boolean, isAnyActiveServices: boolean, isAnyWorkScheduleForWorkingEmployees: boolean, employeesPaginated?: { __typename?: 'EmployeePaginated', totalCount?: number | null } | null, bookingsList?: Array<{ __typename?: 'BookingMainProxy', id: number }> | null }> | null } | null } | null };
